exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.mdl-dialog__content {\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.mdl-dialog__title {\n  font-size: 18px;\n  font-weight: 300;\n  color: #949494;\n  padding-top: 0;\n}\n\n.error {\n  color: #F44336;\n}\n\n", ""]);

// exports
